/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable react/display-name */
import { forwardRef, useEffect } from 'react';
import { JobsListingSuggestedPage } from './suggested';
import { useRouter } from 'next/router';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useSelector } from 'react-redux';
import Head from 'next/head';
export const JobsListingPage = forwardRef(({ ...props }, ref) => {
  const { replace } = useRouter();
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  useEffect(() => {
    if (loggedIn) {
      // replace('/jobs/suggested', undefined, { shallow: true });
      replace('/jobs/suggested');
    } else {
      // replace('/jobs/search', undefined, { shallow: true });
      replace('/jobs/search');
    }
  }, [loggedIn]);
  return (
    <AuthenticatedProviders>
      {/* <JobsListingSuggestedPage /> */}
      {loggedIn ? <JobsListingSuggestedPage /> : null}
    </AuthenticatedProviders>
  );
});

export default JobsListingPage;
